/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Fact_ExploreInputs */

const en_project_fact_explore = /** @type {(inputs: Project_Fact_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore`)
};

const lv_project_fact_explore = /** @type {(inputs: Project_Fact_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apskatīt`)
};

/**
* | output |
* | --- |
* | "Explore" |
*
* @param {Project_Fact_ExploreInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const project_fact_explore = /** @type {((inputs?: Project_Fact_ExploreInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Fact_ExploreInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_project_fact_explore(inputs)
	return en_project_fact_explore(inputs)
});